import { render, staticRenderFns } from "./PaymentAccountSettings.vue?vue&type=template&id=15166966"
import script from "./PaymentAccountSettings.vue?vue&type=script&lang=js"
export * from "./PaymentAccountSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports